// src/pages/ForgotPassword.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../services/api';
import Card from '../components/Card';
import Button from '../components/Button';

function ForgotPassword() {
  const [username, setUsername] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiClient.post('/password-reset/', { username });
      setEnviado(true);
    } catch (error) {
      console.error(error);
      // Incluso si falla, mostramos enviado por seguridad (o podrías mostrar error si prefieres)
      setEnviado(true);
    } finally {
        setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-fondo p-4">
      <Card className="w-full max-w-sm p-8 text-center">
        <h2 className="text-2xl font-bold text-principal mb-4">Recuperar Contraseña</h2>
        
        {!enviado ? (
          <form onSubmit={handleSubmit}>
            <p className="text-gray-600 mb-6 text-sm">
              Introduce tu <b>Nombre de Usuario</b>. Enviaremos un enlace al correo asociado (o al de tu padre/madre).
            </p>
            <div className="mb-6">
              <input 
                type="text" 
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-principal" 
                placeholder="Nombre de usuario"
                required 
              />
            </div>
            <Button type="submit" variant="accent" className="w-full" disabled={loading}>
              {loading ? 'Enviando...' : 'Enviar Enlace'}
            </Button>
          </form>
        ) : (
          <div className="animate-fade-in">
            <div className="text-5xl mb-4">📩</div>
            <p className="text-gray-700 mb-6">
              Si el usuario existe, hemos enviado un correo con las instrucciones.
              <br/><span className="text-sm text-gray-500">(Revisa también Spam)</span>
            </p>
          </div>
        )}

        <div className="mt-6 pt-4 border-t">
          <Link to="/login" className="text-gray-500 hover:text-principal font-bold">
            Volver al Login
          </Link>
        </div>
      </Card>
    </div>
  );
}

export default ForgotPassword;